/**
 * Trigger haptic feedback via Vibration API.
 * Silently fails on unsupported devices.
 */
export function haptic(intensity = "medium") {
  if (!navigator.vibrate) return;

  const patterns = {
    light: [10],
    medium: [20],
    heavy: [40],
    success: [10, 50, 20],
    error: [30, 50, 30, 50, 30],
  };

  try {
    navigator.vibrate(patterns[intensity] || patterns.medium);
  } catch (e) {
    // Silently fail
  }
}
